/*
 * network-toast
 */
import { useNetworkStatus } from "@emr/react-hooks"
import { toast } from "@emr/react-ui"
import { Cloud, CloudOff } from "lucide-react"
import { useEffect, useState } from "react"

export type NetworkToastProps = {
	duration?: number
	className?: string
}

export function NetworkToast({
	duration = 3000,
	className = "gap-3",
}: NetworkToastProps) {
	const [initialized, setInitialized] = useState(false)
	const { isOnline } = useNetworkStatus()

	useEffect(() => {
		if (!isOnline) {
			toast.warning("You are offline", {
				icon: <CloudOff />,
				duration,
				className,
			})
		}
		setInitialized(true)
	}, [])

	useEffect(() => {
		if (!initialized) {
			return
		}
		if (isOnline) {
			toast.success("You're back online", {
				icon: <Cloud />,
				duration,
				className,
			})
		} else {
			toast.error("Lost internet connection", {
				icon: <CloudOff />,
				duration,
				className,
			})
		}
	}, [isOnline])

	return null
}
